import { Box, Button } from "@mui/material";
import Loading from "./loading";

const ButtonComponent = ({
  onClick,
  loading,
  text,
  color = "secondary",
  variant = "contained",
  type = "submit",
  noMargin = false,
}) => {
  return (
    <Box
      sx={{
        display: "inline-flex",
        justifyContent: "flex-start",
        mt: noMargin ? 0 : 2,
        width: "auto",
        flexShrink: 0,
      }}
    >
      <Button
        type={type}
        color={color}
        variant={variant}
        disabled={loading}
        onClick={onClick}
        sx={{ flexShrink: 0, whiteSpace: "nowrap", minWidth: "max-content" }}
      >
        {loading ? <Loading size={8} /> : text}
      </Button>
    </Box>
  );
};

export default ButtonComponent;
